import { render, staticRenderFns } from "./SalaryDetailsModal.vue?vue&type=template&id=4974036d&scoped=true&"
import script from "./SalaryDetailsModal.vue?vue&type=script&lang=js&"
export * from "./SalaryDetailsModal.vue?vue&type=script&lang=js&"
import style0 from "./SalaryDetailsModal.vue?vue&type=style&index=0&id=4974036d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4974036d",
  null
  
)

export default component.exports